import { startsWith } from "lodash"

export type Metrics = (string | undefined | null)[]

export const EMPTY_ARRAY = []

function isValidMetric(metric: unknown): metric is string {
  return typeof metric === "string" && metric.length > 0
}

function normalizeMetric(metric: string, modelId: string): string {
  if (!startsWith(metric, "model")) {
    return metric
  }

  const [, metricModelId, ...values] = metric.split(".")
  if (metricModelId !== modelId) {
    return metric
  }

  return values.join(".")
}

export function getCurrentTemplateMetrics(metrics: Metrics, modelId: string) {
  return metrics
    .filter(isValidMetric)
    .map(metric => {
      return normalizeMetric(metric, modelId)
    })
}
